import {
  Emoji,
  EmojiKey,
  EmojiTag,
  EmojiValue,
} from "../constants/emoji.const";

const emojiEntries = Object.entries(Emoji) as [EmojiKey, EmojiValue][];

export const buildEmojiPlaceholder = (input: EmojiValue | EmojiTag): string => {
  const tag = typeof input === "string" ? input : input.tag;
  return `{{${tag}}}`;
};

const emojiPlaceholderMap: Partial<Record<EmojiKey, string>> = {};
const emojiByTagMap: Partial<Record<EmojiTag, EmojiValue>> = {};

emojiEntries.forEach(([key, value]) => {
  emojiPlaceholderMap[key] = buildEmojiPlaceholder(value);
  emojiByTagMap[value.tag] = value;
});

export const EMOJI = emojiPlaceholderMap as Record<EmojiKey, string>;

export const EMOJI_BY_TAG = emojiByTagMap as Record<EmojiTag, EmojiValue>;

export const isEmojiTag = (tag: string): tag is EmojiTag => tag in EMOJI_BY_TAG;
